// RimoCompta's toast for the context menu and its providers: the compta screen shows it (same channel as the edit
// dialogs, `rimon:toast`). Passed to the shared menu in setup.ts.
export const toast = (text: string, kind: 'success' | 'warning' = 'success') =>
  window.dispatchEvent(new CustomEvent('rimon:toast', { detail: { text, kind } }));
